import { TableRow, TableCell, IconButton, Typography, Collapse, Theme } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Amount } from 'lib/Amount/Amount';
import { calculateCompletion } from 'utils/calculateCompletion';
import { LoanPartsProgress } from '../../../BorderLinearProgress';
import { BridgingRowProps } from 'types/Client';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import BridgingDetails from './BridgingDetails';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    row: {
      cursor: 'pointer',
    },
    opened: {
      'backgroundColor': '#F7F4FC',
      '&:hover td.MuiTableCell-root': {
        backgroundColor: '#F7F4FC',
      },
      '& td.MuiTableCell-root': {
        borderBottom: '0px',
      },
    },
  })
);

function BridgingRow({ bridging, translationsRoot }: BridgingRowProps) {
  const [open, setOpen] = useState(false);
  const principalSum = bridging?.principalSum ?? 0;
  const progress = calculateCompletion(principalSum, bridging.residualDebt, 0) ?? 0;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <TableRow
        className={`${classes.row} ${open ? classes.opened : null}`}
        onClick={() => setOpen(!open)}
        hover
      >
        <TableCell align="left">
          <Typography sx={{ fontWeight: 'bold' }}>{t(`${translationsRoot}.product`)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Amount value={principalSum} />
        </TableCell>
        <TableCell align="left">
          <Amount value={bridging.residualDebt} />
        </TableCell>
        <TableCell align="left">
          {/* TODO: */}
          {/* <PercentageDisplay value={bridging?.effectiveInterestRate} emptyValue="-" /> */}-
        </TableCell>
        <TableCell align="left">
          <LoanPartsProgress variant="determinate" value={progress} />
        </TableCell>
        <TableCell align="left">
          <IconButton aria-label="expand row">{open ? <RemoveIcon /> : <AddIcon />}</IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          colSpan={6}
          padding="none"
          style={{ backgroundColor: '#F7F4FC', border: 'none' }}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <BridgingDetails bridging={bridging} translationsRoot={translationsRoot} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
export default BridgingRow;
